import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';
import { COMERCIO_CORPORATIVO_LOGO_SRC } from '../brandAssets';

const SHOW_LOGO = COMERCIO_CORPORATIVO_LOGO_SRC;

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h2'} gutterBottom align={'center'} marginBottom={'2rem'}>
        ¿Listo para posicionar tu marca ante quienes mueven el país?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={'2rem'}
        color="textSecondary"
      >
        Forma parte de Comercio Corporativo y conecta con ejecutivos, emprendedores y líderes que buscan información para decidir.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography variant="h5" color="textPrimary" sx={{ fontWeight: 700 }}>
                Patrocinio, segmentos temáticos y casos de éxito: tu marca en el programa de negocios de TNO Network.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography variant="body1" component="p" color="textSecondary" sx={{ fontWeight: 400 }}>
                Comercio Corporativo, con Darío Ascanio al frente. Gestión que transforma.
              </Typography>
            </Box>
            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretched', sm: 'flex-start' }}>
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={!isMd}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Patrocinar Comercio Corporativo
              </Button>
              <Box marginTop={{ xs: 2, sm: 0 }} marginLeft={{ sm: 2 }} width={{ xs: '100%', md: 'auto' }}>
                <Button
                  component={'a'}
                  href={'https://www.tnonetwork.com'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={!isMd}
                >
                  TNO Network
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box height={'100%'} width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box
              component="img"
              src={SHOW_LOGO}
              alt="Comercio Corporativo - TNO Network"
              sx={{ width: '100%', maxWidth: 420, height: 'auto', objectFit: 'contain', borderRadius: 2 }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Comercio Corporativo: Economía, gestión y éxito empresarial.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
